import "./index.scss";

export function TermLGPD() {
  return (
    <>
      <div className="container text-gray-700">
        <div className="lgpd flex flex-col gap-7 text-xl">
          <h1 className="text-2xl">PRIVACIDADE</h1>
          <h2 className="text-center font-bold">POLÍTICA DE COOKIES</h2>
          <p className="text-center">Versão de: janeiro de 2022</p>
          <p>
            Mais do que lhe proporcionar uma ferramenta de auxilio administrativo, o INTEGRAADMIN entende cada cliente como pessoas únicas e especiais
            e, por isso, nesse sentido, tem por objetivo, lhes proporcionar uma ferramenta de trabalho para controle administrativo. Trabalhamos com
            total responsabilidade e ética, visando atender com excelência o interesse do investidor, a motivação do profissional e a satisfação do
            consumidor.
          </p>
          <p>
            Fazer isto com transparência, informando como seus dados são utilizados é extremamente importante, por isso, valorizamos e respeitamos
            essas informações.
          </p>
          <p>
            Esta Política de Cookies ("Política") não é um contrato e não cria nenhum direito ou obrigação legal, mas são diretrizes referentes ao
            nosso uso de cookies, sendo aplicada a todos os produtos e serviços do Site www.integraadmin.com.br (“Site”).
          </p>
          <p>Nesta política usamos o termo “cookies” para nos referirmos aos cookies, web beacons e outras tecnologias similares</p>
          <p>Para maiores informações sobre como utilizamos os dados pessoais que obtemos acesso, leia nossa Política de Privacidade.</p>
          <h3>O site do IntegraAdmin utiliza cookies?</h3>
          <p>
            Sim, utilizamos cookies e outras tecnologias similares para que aqueles que acessam o Site do IntegraAdmin tenham a melhor experiência
            possível.
          </p>
          <p>
            Ao continuar a visitar o Site ou usar nossos serviços, você está concordando com a utilização de cookies e tecnologias semelhantes para os
            fins descritos especificamente nesta Política.
          </p>
          <h3>O que é um cookie?</h3>
          <p>
            Um cookie é um pequeno arquivo adicionado ao seu dispositivo ou computador que permite ativar os recursos e funcionalidades do Site. Por
            exemplo, os cookies nos permitem identificar o seu dispositivo ou computador, viabilizando entrar e sair do Site com segurança, e nos
            ajudam a saber se alguém tentou acessar sua conta a partir de um outro dispositivo ou computador. Os cookies também nos permitem
            compartilhar conteúdo do IntegraAdmin com facilidade, ajudando-nos a apresentar anúncios relevantes para você.
          </p>
          <h3>Quando o Site do IntegraAdmin utiliza cookies?</h3>
          <p>
            O IntegraAdmin utiliza cookies em seu Site no momento em que é realizado um acesso pelo usuário. Todos os navegadores que visitarem o Site
            receberão nossos cookies.
          </p>
          <h3>Que tipos de cookies o Site do IntegraAdmin utiliza?</h3>
          <p>
            Usamos dois tipos de cookies: <strong>cookies persistentes e cookies de sessão.</strong>
          </p>
          <p>
            Um <strong>cookie persistente</strong> ajuda a reconhecer o usuário, possibilitando retornar ou interagir com o Site. Depois de entrar na
            sua conta, um cookie persistente permanecerá no seu navegador e será lido pelo IntegraAdmin quando você retornar ao nosso site ou ao site
            de um parceiro que utilize os nossos serviços.
          </p>
          <p>
            Os <strong>cookie de sessão</strong> duram até a sessão terminar (geralmente durante a visita a um Site ou durante uma sessão do
            navegador).
          </p>
          <h3>Para que os cookies são utilizados?</h3>
          <p>
            Os cookies podem ser utilizados para reconhecê-lo quando você acessa o Site do IntegraAdmin, para armazenar suas preferências e para
            proporcionar uma experiência mais personalizada de acordo com suas configurações, além de tornar as suas interações com o Site mais
            rápidas e seguras.
          </p>
          <p>Os cookies também tornam suas interações com o IntegraAdmin mais rápidas e seguras.</p>
          <p>Além disso, os cookies permitem que nós apresentemos publicidade dentro do Site.</p>
          <h3>Controle de cookies</h3>
          <p>
            A maioria dos navegadores permite que você controle cookies em suas configurações. Entretanto, se você limitar a utilização de cookies,
            você não terá a experiência que preparamos para você, pois não haverá mais a personalização.
          </p>
          <p>Você também poderá impedir que configurações personalizadas sejam salvas, como por exemplo, nome de usuário e senha.</p>
          <h3>Como desativar ou remover os cookies?</h3>
          <p>
            Você pode escolher rejeitar ou bloquear tipos específicos de cookies que não sejam essenciais para o funcionamento do Site, configurados
            através da nossa central de privacidade, ao clicar nas preferências de cookies.
          </p>
          <p>
            Porém, se você rejeitar ou apagar a utilização de cookies obrigatórios e essenciais para o funcionamento do Site (alterando cookies
            diretamente no navegador), algumas das funções do Site poderão não funcionar corretamente e o Site, na sua próxima visita, poderá não
            lembrar quais cookies você desativou. Por exemplo, se você desativar o cookie que identifica o usuário.
          </p>
          <p>
            Dessa forma, ao utilizar o nosso Site sem apagar ou rejeitar os cookies obrigatórios, você concorda que podemos posicionar os cookies que
            você não apagou ou rejeitou nos seus dispositivos, para que o Site funcione normalmente e respeite a sua decisão.
          </p>
          <h3>Alterações da Política de Cookies</h3>
          <p>
            O IntegraAdmin pode alterar esta Política de Cookies conforme necessário e a qualquer tempo, sendo as alterações informadas com destaque
            em nosso Site.
          </p>
          <h3>Entre em contato</h3>
          <p>
            Se você tiver dúvidas ou achar que suas preocupações não foram tratadas nesta Política de Cookies, entre em contato enviando um e-mail
            para contato@integraadmin.com.br
          </p>
          <h1 className="text-2xl">PRIVACIDADE</h1>
          <h2 className="text-center font-bold">INTEGRAADMIN</h2>
          <h2 className="text-center font-bold">POLÍTICA DE PRIVACIDADE</h2>
          <p className="text-center">Versão de: janeiro de 2022</p>
          <p>
            A Política de Privacidade da INTEGRAADMIN (“Política”), marca pertencente ao Grupo TEGRA-PP, foi criada para demonstrar o compromisso da
            INTEGRAADMIN com a segurança e a privacidade das informações coletadas dos nossos usuários, sendo estes os titulares dos seus dados
            pessoais (“Usuário”, “Titular” ou simplesmente “você”).
          </p>
          <p>
            A Política esclarece as condições gerais de coleta, uso, armazenamento e demais formas de tratamento e proteção de dados pessoais no site
            www.integraadmin.com.br ("Site") e escritório administrativo da INTEGRAADMIN, em conformidade com a legislação brasileira atualmente em
            vigor em matéria de privacidade e proteção de dados pessoais no Brasil, incluindo, mas não se limitando à Lei nº 12.965, de 23 de abril de
            2014 e Decreto nº 8.771, de 11 de maio de 2016 (“Marco Civil da Internet”) e à Lei nº 13.709, de 14 de agosto de 2018 (“Lei Geral de
            Proteção de Dados” ou “LGPD”).
          </p>
          <p>
            Para efeitos desta Política, o INTEGRAADMIN é qualificada como Controladora, uma vez que armazena as suas informações pessoais, competindo
            a ela as decisões referentes ao tratamento dos seus dados pessoais que por ela forem coletados. Para manter um contato direto com você,
            foi designado pela INTEGRAADMIN um Encarregado pelo Tratamento de Dados Pessoais para administrar um canal de comunicação. Se você tiver
            quaisquer dúvidas relacionadas às atividades de tratamento de dados pessoais sob nossa responsabilidade ou questionamentos e comentários
            referentes à presente Política, por favor envie um e-mail para contato@integraadmin.com.br, aos cuidados de Larissa Rodrigues.
          </p>
          <p>
            Ao utilizar nosso Site, você manifesta de maneira livre, informada, inequívoca, expressa e integral a sua concordância com esta Política.{" "}
            <span className="underline">Recomendamos a sua leitura atenta.</span>
          </p>
          <ul className="font-bold">
            <li>• ABRANGÊNCIA</li>
            <li>• INFORMAÇÕES QUE COLETAMOS</li>
            <li>• BASE LEGAL PARA O TRATAMENTO DE DADOS PESSOAIS</li>
            <li>• FINALIDADE DA COLETA DE DADOS</li>
            <li>• COMPARTILHAMENTO DE DADOS PESSOAIS</li>
            <li>• PERSONAL SHOPPER</li>
            <li>• DIREITO DOS TITULARES DE DADOS PESSOAIS</li>
            <li>• COMO ARMAZENAMOS E TRATAMOS OS DADOS PESSOAIS</li>
            <li>• TRANSFERENCIA INTERNACIONAL DE DADOS PESSOAIS</li>
            <li>• TEMPO DE RETENÇÃO DAS INFORMAÇÕES</li>
            <li>• PRAZO E ALTERAÇÕES</li>
            <li>• POLÍTICA DE COMUNICAÇÃO</li>
            <li>• CONEXÕES (LINKS) A OUTROS SITES</li>
          </ul>
          <h3>1. ABRANGÊNCIA</h3>
          <p>A presente Política aplica-se a todos os usuários do Site, sendo coletados os seus dados pessoais sempre que você:</p>
          <ul>
            <li>• Visitar, interagir ou se cadastrar no site do INTEGRAADMIN (www.integraadmin.com.br);</li>
            <li>• Efetuar uma compra no Site;</li>
            <li>• Entrar em contato conosco pelos nossos canais de atendimento;</li>
          </ul>
          <h3>2. INFORMAÇÕES QUE COLETAMOS</h3>
          <p>
            Importante: Você não é obrigado a nos conceder suas informações, entretanto, sem conceder certas informações quando estas forem
            solicitadas, não lhe será permitido o acesso a algumas funcionalidades. Além dos dados que você nos informa, sempre que você interagir com
            o nosso site, o INTEGRAADMIN coletará informações de forma automática. Tais informações geralmente não são identificáveis, porém, quando
            combinadas com outros dados gerando a capacidade de se associar a você, será tratado pelo INTEGRAADMIN como dado pessoal.
          </p>
          <p>
            A natureza e a finalidade dos dados pessoais que coletamos diferem de acordo com a área do site acessada (por exemplo, se você é um
            comprador dos nossos serviços ou simplesmente um visitante do site do INTEGRAADMIN que está entrando em contato conosco).
          </p>
          <p>
            Nos limites permitidos pela legislação aplicável, o INTEGRAADMIN poderá tratar os seguintes dados pessoais que por você nos forem
            informados:
          </p>
          <p>
            <strong>Cadastro da Conta:</strong> nome, sobrenome, e-mail, CPF, gênero, data de nascimento, telefone, CEP, endereço completo.
          </p>
          <p>
            <strong>Conteúdo do usuário:</strong> conteúdo de comunicações, sugestões, perguntas, comentários, feedback e outras informações que você
            nos envia, que nos fornece quando entra em contato.
          </p>
          <p>
            <strong>Informações de cobrança:</strong> número do cartão, nome impresso no cartão, validade, código de segurança, nome (tipo) do
            documento e número do documento, endereço de fatura do cartão.
          </p>
          <p>
            Conforme anteriormente informado, o INTEGRAADMIN poderá coletar automaticamente as informações listadas abaixo, mesmo que você não tenha
            criado ou acessado uma conta no INTEGRAADMIN:
          </p>
          <p>
            <strong>Informações de geolocalização:</strong> localização precisa ou aproximada determinada a partir do seu endereço IP ou GPS do
            dispositivo móvel, dependendo das configurações do seu dispositivo;
          </p>
          <p>
            <strong>Dados de log e informação do seu dispositivo:</strong> detalhes sobre como você usou o site do INTEGRAADMIN (quais páginas do
            nosso site foram visitadas, a ordem em que foram visitadas, quando foram visitadas, quais links foram clicados, bem como se você clicou em
            links para aplicativos de terceiros), endereço de IP ou outro identificador único (Device Identifier), datas e horários de acesso,
            informações de hardware e software, informações do dispositivo, informações de eventos do seu dispositivo, identificadores exclusivos,
            dados de falha, dados de cookies e as páginas que você visualizou ou interagiu antes e depois de usar o INTEGRAADMIN.
          </p>
          <p>
            <strong>Cookies e tecnologias semelhantes:</strong> de acordo com a Política de Cookies.
          </p>
          <p>
            Note que os dados pessoais listados acima serão coletados pelo INTEGRAADMIN e posteriormente tratados somente conforme necessário para
            atingir as finalidades aqui previstas.
          </p>
          <p>
            Não coletamos, armazenamos ou de outra forma tratamos intencionalmente dados pessoais excessivos ou desnecessários para a prestação dos
            nossos serviços e utilização do nosso site, dados considerados sensíveis (aqueles relativos à sua origem racial ou étnica, convicção
            religiosa, opinião política, filiação a sindicato ou a organização de caráter religioso, filosófico ou político, saúde ou orientação
            sexual, bem como dado genético) e dados de menor de idade sem o consentimento do seu responsável. Em função disso, pedimos que você se
            abstenha de compartilhá-los conosco. Se ficarmos cientes que houve a coleta e o tratamento inadvertido destes dados, estes serão apagados
            dos nossos registros.
          </p>
          <h3>3. BASE LEGAL PARA O TRATAMENTO DE DADOS PESSOAIS</h3>
          <p>
            A classificação da base legal dos dados armazenados e processados pelo INTEGRAADMIN listados na Seção 2 ocorre mediante análise do
            contexto específico em que os coletamos.
          </p>
          <p>Os dados tratados pelo INTEGRAADMIN tendem a ser coletados somente:</p>
          <ul>
            <li>• Com o seu consentimento;</li>
            <li>• Para o cumprimento de obrigação legal ou regulatória</li>
            <li>• Para o exercício regular de direitos em processo judicial;</li>
            <li>
              • Quando o processamento dos dados pessoais está de acordo com os interesses legítimos do INTEGRAADMIN, sempre com atenção aos seus
              interesses relacionados à proteção de dados ou liberdades e direitos fundamentais. Também haverá a necessidade de processamento de seus
              dados para proteger seus interesses ou de terceiros.
            </li>
          </ul>
          <h3>4. FINALIDADE DA COLETA DE DADOS</h3>
          <p>
            A coleta das informações tem como objetivo único e exclusivo a manutenção e o aprimoramento dos benefícios disponibilizados para oferecer
            uma melhor experiência para você. Desta forma, conforme necessário, as informações coletadas serão utilizadas para os seguintes
            propósitos:
          </p>
          <ul>
            <li>• Permitir que você acesse o site do INTEGRAADMIN, fornecendo acesso a determinadas áreas e recursos;</li>
            <li>• Atender aos seus eventuais questionamentos, solicitações de informações sobre o INTEGRAADMIN e fale conosco;</li>
            <li>
              • Comunicar-se com você sobre a sua conta e atividades no Site do INTEGRAADMIN, bem como enviar comunicações institucionais sobre o
              INTEGRAADMIN;
            </li>
            <li>• Prestar serviço de suporte técnico quando necessário;</li>
            <li>
              • Repassar as suas informações a parceiros de negócios e provedores de conteúdo quando legalmente autorizado e para atingir a finalidade
              específica;
            </li>
            <li>• Melhorar o nosso site;</li>
            <li>• Personalizar e customizar a sua experiência no site do INTEGRAADMIN;</li>
            <li>• Desenvolver novos produtos e serviços;</li>
            <li>
              • Repasse a autoridades governamentais quando a solicitação se der por meio de intimações, ordens judiciais ou outros processos legais
              para estabelecer ou exercer nossos direitos legais, proteger nossa propriedade, nos defendermos de reivindicações legais ou conforme
              exigido por lei;
            </li>
            <li>• Cessar o vínculo com o usuário (por exemplo, quando o usuário solicita o cancelamento do seu cadastro);</li>
            <li>
              • Enviar a você mensagens promocionais, marketing, prospecção, pesquisas de mercado, de opinião e promoção dos nossos produtos, ou de
              nossos parceiros;
            </li>
            <li>
              • Investigar, impedir ou adotar medidas relacionadas a atividades ilegais, suspeita de fraude ou situações que envolvam ameaças em
              potencial à segurança física e tecnológica de qualquer pessoa, empresas parceiras do INTEGRAADMIN, ou se de outra maneira exigido
              legalmente, nos limites permitidos pela legislação aplicável.
            </li>
          </ul>
          <h3>5. COMPARTILHAMENTO DE DADOS PESSOAIS</h3>
          <p>
            Quando necessário para atingir as finalidades descritas no item 4 acima, o INTEGRAADMIN poderá compartilhar seus dados pessoais com
            terceiros listados abaixo visando a correta prestação dos serviços ofertados, a segurança de armazenamento dos seus dados pessoais e uma
            melhor experiência junto ao INTEGRAADMIN. Sempre que efetuado, o compartilhamento de dados será realizado dentro dos limites e propósitos
            do nosso negócio, em conformidade com a finalidade dos dados pessoais e de acordo com o que autoriza a legislação aplicável. Dessa forma,
            os seus dados poderão ser compartilhados com:
          </p>
          <ul className="px-5">
            <li>
              • Com outras Empresas do Grupo TEGRA - PP, que se comprometem a utilizar as informações para os mesmos fins indicados na presente
              Política;
            </li>
            <li>• Plataformas e ferramentas de software de terceiros para fins de gestão da prestação dos serviços ofertados pelo INTEGRAADMIN;</li>
            <li>
              • Com empresas parceiras e fornecedores, no desenvolvimento dos Serviços voltados ao Titular, inclusive com empresas responsáveis por
              atualizar e manter a qualidade dos dados de nossos clientes;
            </li>
            <li>• Empresas de marketing e publicidade;</li>
            <li>
              • Autoridades fiscais e órgãos governamentais, policiais, públicos e judiciais com o propósito de responder a denúncias, investigações,
              medidas judiciais e processos judiciais; bem como cumprir com obrigações legais, regulatórias e fiscais.
            </li>
            <li>• Outros prestadores de serviço que podem ser acionados conforme necessário no caso concreto.</li>
          </ul>
          <h3>6. DIREITOS DOS TITULARES DE DADOS PESSOAIS</h3>
          <p>
            Na forma e nos limites da legislação aplicável, você, na qualidade de titular de dados pessoais, poderá entrar em contato conosco para
            exercer seus direitos, de modo a requerer:
          </p>
          <ul>
            <li>• a confirmação da existência de tratamento de seus dados pessoais;</li>
            <li>• o acesso aos seus dados;</li>
            <li>• a correção de seus dados incompletos, inexatos ou desatualizados;</li>
            <li>
              • a anonimização, bloqueio ou eliminação de seus dados que sejam desnecessários, excessivos, ou tratados em desconformidade com o
              disposto na legislação aplicável;
            </li>
            <li>• a portabilidade dos seus dados a outro fornecedor de serviço ou produto, observados os segredos comercial e industrial;</li>
            <li>
              • a eliminação dos seus dados pessoais, exceto nas hipóteses previstas na legislação aplicável, para exercícios de direitos atinentes ao
              INTEGRAADMIN e para o cumprimento de exigências legais;
            </li>
            <li>• a informação das entidades públicas e privadas com as quais o INTEGRAADMIN compartilhou seus dados;</li>
            <li>• a informação sobre a possibilidade de você não fornecer consentimento e sobre as consequências da sua negativa;</li>
            <li>
              • a revogação do seu consentimento, quando você tiver nos fornecido, resguardado o interesse público que possa justificar a continuidade
              do tratamento ou a existência de outra base legal que autorize; e
            </li>
            <li>
              • a oposição a qualquer tratamento de dados pessoais com fundamento em uma das hipóteses em que seu consentimento é dispensado, desde
              que tenha ocorrido o descumprimento ao disposto na legislação aplicável e resguardado o interesse público que possa justificar a
              continuidade do tratamento.
            </li>
          </ul>
          <p>
            O seu requerimento poderá ser feito gratuitamente através do nosso site, disponível em www.integraadmin.com.br Analisaremos seu pedido e o
            atenderemos com a maior brevidade possível, considerando os prazos e os termos previstos na legislação aplicável. Caso não seja possível
            atender imediatamente a sua requisição, indicaremos as razões de fato e de direito que nos impedem.
          </p>
          <p>
            O INTEGRAADMIN não se responsabiliza pela correção, veracidade, autenticidade, completude e atualização dos dados prestados pelo Titular,
            nem mesmo pelo eventual uso indevido de informações por ele publicadas por ou por fraudes decorrentes da violação de senhas pessoais.
          </p>
          <p>
            É de sua exclusiva responsabilidade prestar unicamente informações corretas, verdadeiras, autênticas, completas e atualizadas, bem como
            zelar pelo sigilo de sua senha, quando aplicável, não a divulgando a terceiros.
          </p>
          <h3>7. COMO ARMAZENAMOS E TRATAMOS OS DADOS PESSOAIS</h3>
          <p>
            O INTEGRAADMIN mantém em ambiente controlado e de segurança os dados pessoais coletados, visando atender finalidades específicas, conforme
            exposto na Seção 4. Os dados pessoais coletados são mantidos em sigilo, com controle estrito de acesso, mediante mecanismos de
            autenticação.
          </p>
          <p>
            O INTEGRAADMIN adota medidas de segurança, técnicas e administrativas para manter em segurança todos os dados armazenados. Especificamente
            com relação aos dados coletados através do nosso site, eles são armazenados, tratados e protegidos mediante as melhores práticas de
            hospedagem, processamento, backup e criptografia, de acordo com a sua respectiva criticidade.
          </p>
          <p>
            Mesmo assim, o Titular deve ter ciência que nenhum sistema de segurança na Internet é garantido contra invasões indesejadas, sendo que o
            compromisso do INTEGRAADMIN se limita à adoção de medidas de proteção recomendáveis de acordo com o atual estado da técnica.
          </p>
          <h3>8.TRANSFERÊNCIA INTERNACIONAL DE DADOS PESSOAIS</h3>
          <p>
            O INTEGRAADMIN poderá transferir alguns de seus dados pessoais a prestadores de serviços e parceiros localizados no exterior, incluindo
            prestadores de serviços em nuvem. Quando seus dados pessoais forem transferidos para fora do Brasil pelo INTEGRAADMIN, adotaremos medidas
            apropriadas para garantir a proteção adequada de seus dados pessoais em conformidade com os requisitos da legislação aplicável de proteção
            de dados, incluindo por meio da celebração de contratos apropriados de transferência de dados com terceiros, quando necessário.
          </p>
          <h3>9. TEMPO DE RETENÇÃO DAS INFORMAÇÕES</h3>
          <p>
            Armazenamos e mantemos suas informações: (i) pelo tempo exigido por lei; (ii) até o término do tratamento de dados pessoais, conforme
            mencionado abaixo; (iii) pelo tempo necessário a preservar o legitimo interesse do INTEGRAADMIN, conforme o caso; (iv) pelo tempo
            necessário para resguardar o exercício regular de direitos do INTEGRAADMIN em processo judicial, administrativo ou arbitral. Assim,
            trataremos seus dados, por exemplo, durante os prazos prescricionais aplicáveis ou enquanto necessário para cumprimento de obrigação legal
            ou regulatória.
          </p>
          <p>O término do tratamento de dados pessoais ocorrerá nos seguintes casos:</p>
          <ul>
            <li>
              • Quando a finalidade pela qual os dados pessoais do Titular foram coletados for alcançada e/ou os dados pessoais coletados deixarem de
              ser necessários ou pertinentes ao alcance de tal finalidade;
            </li>
            <li>• Quando o Titular estiver em seu direito de solicitar o término do tratamento e a exclusão de seus dados pessoais e o fizer; e</li>
            <li>• Quando houver uma determinação legal neste sentido.</li>
          </ul>
          <p>
            Observando o princípio da necessidade, alguns dados encaminhados por meio do nosso Site podem ser excluídos dos nossos registros mediante
            a manutenção de registros de rotina. Não temos a obrigação de armazenar os dados pessoais por tempo indeterminado e nos isentamos de
            qualquer responsabilidade decorrente ou relacionada à destruição destes dados pessoais.
          </p>
          <p>
            Havendo o término do tratamento de seus dados pessoais, ressalvadas as hipóteses estabelecidas pela legislação aplicável ou pela presente
            Politica de Privacidade, eles serão eliminados do banco de dados do INTEGRAADMIN. Caso não seja possível a eliminação em um primeiro
            momento, os dados serão armazenados com segurança e isolados de qualquer processamento posterior, até que a eliminação seja possível.
          </p>
          <h3>10. PRAZO E ALTERAÇÕES</h3>
          <p>
            O nosso Site, no todo ou em cada uma das suas abas e seções, pode ser encerrado, suspenso ou interrompido unilateralmente pelo
            INTEGRAADMIN, a qualquer momento e sem necessidade de prévio aviso, caso em que informaremos onde serão disponibilizadas as informações
            dele constante, cujo acesso seja seu direito em conformidade com a legislação em vigor.
          </p>
          <p>
            A presente Política de Privacidade poderá vir a ser atualizada ou alterada a qualquer tempo, sendo as alterações informadas com destaque
            em nosso site.
          </p>
          <h3>11. POLÍTICA DE COMUNICAÇÃO</h3>
          <p>
            Nós buscamos evitar o envio de e-mails não-solicitados, restringindo as comunicações com você a assuntos que sejam relevantes ou do seu
            específico interesse.
          </p>
          <p>Quando você realiza seu cadastro, podemos contatá-lo através dos meios de comunicação ali informados.</p>
          <p>
            Se você preferir não receber mais nossas informações referentes aos nossos serviços, informativos e promoções, você pode solicitar seu
            recadastramento através do link de cancelamento de inscrição contido no próprio e-mail ou na mensagem recebida, ou desmarcar a opção que
            autoriza o envio de e-mails e mensagens promocionais (opt out) presente na sua página de cadastro.
          </p>
          <p>
            Você deve ter ciência de que diversos fraudadores tentam se valer de marcas de produtos com tradição para obter informações pessoais como
            senhas e dados financeiros. O INTEGRAADMIN NUNCA IRÁ SOLICITAR SUA SENHA E/OU DADOS FINANCEIROS ATRAVÉS DE E-MAIL OU CONTATO TELEFÔNICO.
            NO CASO DE QUALQUER OUTRA ATITUDE SUSPEITA, ENCAMINHE SUA DÚVIDA OU ALERTA POR E-MAIL PARA contato@integraadmin.com.br
          </p>
          <h3>12. CONEXÕES (LINKS) A OUTROS SITES</h3>
          <p>
            Nosso site pode conter links ou frames de outros sites. Esses links ou frames buscam proporcionar benefícios adicionais aos conteúdos e
            serviços oferecidos ao Titular.
          </p>
          <p>
            Esclarecemos que a inclusão desses links em nosso site não significa que o INTEGRAADMIN tenha conhecimento, concorde ou seja responsável
            pelo conteúdo de referidos links e frames. É importante ressaltar que nosso objetivo é o de somente disponibilizar links ou frames de
            empresas idôneas e confiáveis, não sendo o INTEGRAADMIN responsável pelas informações, produtos e serviços obtidos pelo Titular nos
            referidos sites, nem tampouco pelas práticas comerciais e políticas de privacidade adotadas por essas empresas, não podendo o INTEGRAADMIN
            ser responsabilizado por eventuais perdas e danos ou lucros cessantes sofridos em razão da utilização desses recursos.
          </p>
          <p>
            Na medida em que os sites vinculados não fazem parte do Site do INTEGRAADMIN, nós não controlamos, recomendamos ou endossamos esses sites
            e seus conteúdos, produtos, serviços, políticas e suas práticas de privacidade; não temos acesso aos seus dados pessoais coletados e
            tratados por eles e às suas políticas de publicidade, cookies e termos de uso. Dessa forma, recomendamos a sua leitura atenta a estes
            documentos de sites terceiros.
          </p>
          <p>Ao utilizar os nossos serviços, você concorda e aceita os termos aqui dispostos.</p>
        </div>
      </div>
    </>
  );
}
